// Commerce Ace — Recent Projects: Slider + Lightbox

(function () {

  // === LIGHTBOX ===
  const lightbox = /** @type {HTMLElement | null} */ (document.getElementById('ca-lightbox'));
  const lightboxTitle = /** @type {HTMLElement | null} */ (document.getElementById('ca-lightbox-title'));
  const lightboxBody = /** @type {HTMLElement | null} */ (document.getElementById('ca-lightbox-body'));
  const lightboxImage = /** @type {HTMLImageElement | null} */ (document.getElementById('ca-lightbox-image'));
  const lightboxClose = lightbox ? /** @type {HTMLElement | null} */ (lightbox.querySelector('.ca-lightbox__close')) : null;
  const lightboxOverlay = lightbox ? /** @type {HTMLElement | null} */ (lightbox.querySelector('.ca-lightbox__overlay')) : null;

   /**
   * @param {string} title
   * @param {string} body
   * @param {string} image
   * @param {string} videoUrl
   */
  function openLightbox(title, body, image, videoUrl) {
    if (!lightbox || !lightboxTitle || !lightboxBody || !lightboxImage) return;
    lightboxTitle.textContent = title;

    // Inject video trigger if URL present
    let bodyContent = body;
    if (videoUrl) {
      bodyContent += `<p style="margin-top: 1.25rem;"><button class="ca-video-trigger" data-video-url="${videoUrl}" style="background:none;border:none;padding:0;color:#f53535;font-family:inherit;font-size:0.9375rem;cursor:pointer;text-decoration:underline;">🎬 Want to see this feature in action? Watch the demo</button></p>`;
    }

    lightboxBody.innerHTML = bodyContent;

    if (image) {
      lightboxImage.style.opacity = '0';
      lightboxImage.src = '';
      lightboxImage.alt = title;
      lightboxImage.style.display = 'block';
      const tempImg = new Image();
      tempImg.onload = function() {
        lightboxImage.src = image;
        lightboxImage.style.transition = 'opacity 0.3s ease';
        lightboxImage.style.opacity = '1';
      };
      tempImg.src = image;
    } else {
      lightboxImage.style.display = 'none';
    }
    lightbox.classList.add('is-open');
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxOverlay) lightboxOverlay.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  // === READ MORE BUTTONS ===
  document.querySelectorAll('.ca-projects__read-more').forEach(function (btn) {
    const button = /** @type {HTMLElement} */ (btn);
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      openLightbox(
        button.dataset.title || '',
        button.dataset.body || '',
        button.dataset.image || '',
        button.dataset.videoUrl || ''
      );
    });
  });

  // === CARD CLICK ===
  document.querySelectorAll('.ca-projects__card').forEach(function (el) {
    const card = /** @type {HTMLElement} */ (el);
    card.addEventListener('click', function () {
      openLightbox(
        card.dataset.title || '',
        card.dataset.body || '',
        card.dataset.image || '',
        card.dataset.videoUrl || ''
      );
    });
  });

  // === SLIDER ===
  document.querySelectorAll('.ca-projects__cards--slider, .ca-projects__cards--mobile-slider').forEach(function (el) {
    const slider = /** @type {HTMLElement} */ (el);
    const wrapper = slider.closest('.ca-projects__slider-wrapper');
    if (!wrapper) return;

    const prevBtn = /** @type {HTMLButtonElement | null} */ (wrapper.querySelector('.ca-projects__arrow--prev'));
    const nextBtn = /** @type {HTMLButtonElement | null} */ (wrapper.querySelector('.ca-projects__arrow--next'));
    const cards = /** @type {NodeListOf<HTMLElement>} */ (slider.querySelectorAll('.ca-projects__card'));
    const visibleCount = window.innerWidth <= 768 ? 1 : 3;
    const maxIndex = Math.max(0, cards.length - visibleCount);
    let currentIndex = 0;

    function updateSlider() {
      const cardEl = cards[0];
      if (!cardEl) return;
      const cardWidth = cardEl.getBoundingClientRect().width;
      const gap = 32;
      const offset = currentIndex * (cardWidth + gap);
      slider.scrollLeft = offset;
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentIndex < maxIndex) {
          currentIndex++;
          updateSlider();
        }
      });
    }

    // === SWIPE ===
    let startX = 0;
    let isDragging = false;

    slider.addEventListener('touchstart', function (e) {
      const touch = /** @type {TouchEvent} */ (e);
      startX = touch.touches.item(0)?.clientX ?? 0;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      const touch = /** @type {TouchEvent} */ (e);
      const diff = startX - (touch.changedTouches.item(0)?.clientX ?? 0);
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < maxIndex) {
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          currentIndex--;
        }
        updateSlider();
      }
      isDragging = false;
    }, { passive: true });

    updateSlider();
  });

})();